import * as bg07 from '../actions/bg07.actions';
import * as moment from 'moment';
export interface State {
  page_content: any;
}
export const initialState = {
    page_content: {}
};

export function reducer(state = initialState, action: bg07.Actions) {
  switch (action.type) {
    case bg07.GO_TO_PAGE_BG07: {
      const data = transformResponse(action.payload);
      return Object.assign({}, state, {
        ...state,
        page_content: {
          data: data.data,
          noOfRecords: data.noOfRecords
        }
      });
    }

    default:
      return state;
  }
}

function transformResponse(data) {
  return {
    noOfRecords: data.length,
    data: data.map(e => {
      return {
        BG07_16: e['clientName'],
        BG07_17: e['policyNo'],
        BG07_18: moment(e['dob']).format('YYYY-MM-DD'),
        BG07_19: e['phoneNo_Home'] + '<br>' + e['phoneNo_Mobile'] + '<br>' + e['phoneNo_Office'],
        BG07_20: e['emailAddress'],
        BG07_21: e['address']
      };
    })
  };
}
